export default __webpack_public_path__ + "static/media/MaskGroup209.a70013c6.png";